export { default, handle, links, meta } from "./routes/signup/route.tsx";